export default __webpack_public_path__ + "static/bar-b72229039db84022f8e8e95c2720e9cd.png";